import { render, staticRenderFns } from "./clock_detail.vue?vue&type=template&id=93150648&scoped=true&"
import script from "./clock_detail.vue?vue&type=script&lang=js&"
export * from "./clock_detail.vue?vue&type=script&lang=js&"
import style0 from "./clock_detail.vue?vue&type=style&index=0&id=93150648&prod&scoped=true&lang=css&"
import style1 from "./clock_detail.vue?vue&type=style&index=1&id=93150648&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93150648",
  null
  
)

export default component.exports